import React, { Component } from 'react'
import { connect } from 'react-redux';
import Header from '../../components/Header';
import BarraLateral from '../../components/BarraLateral';
import Agrupador from '../../components/crud/Agrupador';
import TipoSignatario from '../../components/crud/TipoSignatario';
import Usuarios from '../../components/crud/Usuarios';
import { limpa_msgs } from '../../actions';

class CrudScreen extends Component {
    state = { 
        formPWA: { 
            bgcolors: ['',''] 
        },
        tipoCrud: this.props.match.params.tipo || ''
    }

    getType = () => {
        var crud, modal = null
        switch(this.state.tipoCrud.toLowerCase()){
            case 'agrupador': 
                crud = <Agrupador />; 
                modal = 'modalFormAgrupador'
            break;
            case 'tipo-signatario':
                crud = <TipoSignatario />
                modal = 'modalFormTiposSig'
            break;
            case 'usuarios':
                crud = <Usuarios />
                modal = 'modalFormUser'
            break;
        }
        window.feather.replace()
        return { crud, modal }
    }

    render(){
        return(
            <div className="principal">

                <Header />

                <div className="row" style={{width:'100%',marginLeft:'auto',marginRight:'auto'}}>
                    <BarraLateral />
                    <main role="main" className="col-md-10 ml-sm-auto col-lg-10 px-3" style={customStyles.main}>
                       
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mt-3 ">
                                <li className="breadcrumb-item active" aria-current="page">Configurações</li>
                                <li className="breadcrumb-item active" aria-current="page">Dashboard</li>
                                <li className="breadcrumb-item active" aria-current="page" style={{ textTransform:'capitalize'}}>{(this.state.tipoCrud || '').replace(/-/gi,' ')}</li>
                            </ol>
                        </nav>
                        
                        <div className="bg-white rounded shadow-sm p-3">    
                            <div style={{ marginBottom: 10 }}>
                                <button className="btn btn-primary" data-toggle="modal" data-target={`#${this.getType().modal}`} onClick={ () => this.props.limpa_msgs()}>
                                    Novo <span data-feather="plus"></span>
                                </button>
                            </div>               
                            {this.getType().crud}
                        </div>

                    </main>
                </div>

                <style>
                {
                    `
                    .inputFile.custom-file-input:lang(en)~.custom-file-label::after {
                        content: "Selecionar";
                        background-color: #007bff;
                        color: white;
                    }
                    `
                }
                </style>

            </div>
        )
    }
}

const customStyles = {
    main: {

    }
}

const mapStateToProps = ({ auth, documentos }) => {
    return {
        documentos, auth
    }
}

export default connect(mapStateToProps, {
    limpa_msgs
})(CrudScreen);